import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "urlFormat"
})
export class UrlFormatPipe implements PipeTransform {
    public transform(value: string | null | undefined): string {
        if (!value) {
            return "";
        }

        return value.replace(/^https?:\/\//i, "").replace(/\/$/, "");
    }
}
